<template>
  <div id="pre-qualify-reproved-page" :class="{ mobile: isMobile() }">
    <CloseButton dark sameBgInMobile />
    <div class="header">
      <AssetV3
        class="logo"
        dir="logos"
        name="logo-white.svg"
      />

      <div class="header-content">
        <h1>
          Infelizmente não foi desta vez
        </h1>
      </div>

      <AssetV3
        dir="persons"
        name="shocked-guy.svg"
        class="shocked-guy"
      />
    </div>
    <div class="container">
      <p>
        {{ infoDeniedMessage }}
      </p>

      <ProgressBar
        class="credit-progress-bar"
        :start="failedDates.start"
        :end="failedDates.end"
        endText="NOVA APLICAÇÃO"
      />

      <div class="simulation-button">
        <button @click="handleClose">
          Continuar minha compra
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';

import UtilMixin from '@/mixins/util';
import AssetV3 from '@/components/common/AssetV3.vue';
import ProgressBar from '@/components/common/ProgressBar.vue';
import CloseButton from '../components/CloseButton.vue';

export default {
  name: 'preQualify-reproved',
  components: {
    CloseButton,
    AssetV3,
    ProgressBar,
  },
  mixins: [UtilMixin],
  computed: {
    ...mapState('preQualify', [
      'hasPreCondition',
    ]),
    ...mapGetters('preQualify', [
      'infoDeniedMessage',
    ]),
    failedDates() {
      return {
        start: moment().toISOString(),
        end: moment().add(60, 'days').toISOString(),
      };
    },
  },
  methods: {
    ...mapActions('preQualify', [
      'close',
      'emitEvent',
      'updatePreCondition',
    ]),
    handleClose() {
      this.close();
    },
  },
  mounted() {
    if (this.hasPreCondition) {
      this.emitEvent({
        type: 'predenied',
      });
    } else {
      this.emitEvent({
        type: 'denied',
      });
    }
    this.updatePreCondition(true);
  },
};
</script>

<style lang="scss" scoped>
#pre-qualify-reproved-page {
  position: relative;
  width: 600px;
  min-height: 580px;
  margin: 0 auto;

  .header {
    box-sizing: border-box;
    height: 300px;

    position: relative;
    padding: 20px 0 20px 36px;
    min-height: 300px;

    background-image: url('https://s3.amazonaws.com/cdn.parcelex.com.br/assets/v3/background/primary-gradient-waves.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    .header-content {
      display: flex;

      h1 {
        font-size: 28px;
        color: var(--white);
        margin: 36px 0 90px 0px;
        text-align: left;
        max-width: 60%;
      }
    }

    .shocked-guy {
      position: absolute;
      right: 19px;
      bottom: 0;
      width: auto;
      height: 281px;
    }

    h2 {
      margin-top: 36px;
    }
  }

  .container {
    margin: 24px 0;
    text-align: left;

    p {
      @extend .body-regular;
      color: var(--gray-700);
      margin-bottom: 24px;
    }

    h2 {
      @extend .gray-600;
      margin-top: 20px;
    }

    .simulation-button {
      display: flex;
      justify-content: center;

      button {
        @extend .primary;
        margin-top: 24px;
      }
    }
  }

  &.mobile {
    margin: 0;
    width: 100%;
    position: static;

    .header {
      min-height: 222px;
      height: 222px;

      .shocked-guy {
        display: none !important;
      }
    }

    .header-content {
      h1 {
        margin: 0;
        margin-top: 24px;
        max-width: none;
      }
    }

    .container {
      .simulation-button {
        position: absolute;
        bottom: 20px;
        width: calc(100% - 48px);

        button {
          height: 48px;
        }
      }

      h2 {
        font-size: 22px;
        line-height: 24px;
      }

      button {
        width: 100%;
      }
    }
  }
}
</style>
